import { Injectable } from "@angular/core";
import { AlertController, isPlatform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
interface customPermissionParams {
  header: string;
  acceptTitle: string;
  cancelTitle?: string;
  other?: string;
}
@Injectable({
  providedIn: "root",
})
export class AlertService {
  constructor(
    private alertCtrl: AlertController,
    private translateService: TranslateService
  ) {}

  showAlertRemoveFile() {
    return new Promise(async (resolve: any) => {
      const message = this.translateService.instant("ARE_YOU_SURE");
      const title = this.translateService.instant("REMOVE_FILE");
      const alert = await this.alertCtrl.create({
        header: title,
        message,
        buttons: [
          {
            text: this.translateService.instant("CANCEL"),
            role: "cancel",
            handler: () => resolve(false),
          },
          {
            text: this.translateService.instant("CONTINUE"),
            handler: () => resolve(true),
          },
        ],
      });
      alert.addEventListener('ionAlertDidPresent', () => {
        const wrapper = document.querySelector(
          'ion-alert .alert-wrapper'
        );

        wrapper?.setAttribute('role', 'dialog');
      });
      await alert.present();
    });
  }

  emailAlert(message: string) {
    return new Promise(async (resolve: any) => {
      const title = this.translateService.instant("EMAIL_PRINTING");
      const alert = await this.alertCtrl.create({
        header: title,
        message,
        cssClass: 'email-alert'
        // buttons: [
        //   {
        //     text: 'Cancel',
        //     role: 'cancel',
        //     handler: () => resolve(false),
        //   },
        //   {
        //     text: 'Continue',
        //     handler: () => resolve(true),
        //   },
        // ],
      });
      await alert.present();
    });
  }

  async customPermissionPopup(param: customPermissionParams) {
    return new Promise(async (resolve: any) => {
      const buttons = [];
      if (param.cancelTitle) {
        buttons.push({
          text: param.cancelTitle,
          cssClass: "alert-button-cancel",
          handler: () => resolve(false),
        });
      }
      if (param.other) {
        buttons.push({
          text: param.other,
          cssClass: `alert-button-other ${
            !param.cancelTitle && isPlatform("ios") ? " btn-round-left" : ""
          }`,
          handler: () => resolve(param.other),
        });
      }
      buttons.push({
        text: param.acceptTitle,
        cssClass: "alert-button-confirm",
        handler: () => resolve(true),
      });
      const alert = await this.alertCtrl.create({
        subHeader: param.header,
        cssClass: "custom-alert",
        buttons,
        backdropDismiss: false,
      });

      await alert.present();
    });
  }

  async customAlert(header, subHeader, message, buttons){
    const alert = await this.alertCtrl.create({
      header,
      subHeader,
      message,
      buttons,
      backdropDismiss: false,
      cssClass: 'custom-alert-wrapper',
      mode: "ios"
    });

   await alert.present();
   return alert;
  }

  async emailPrintingAlert(){
    return new Promise(async (resolve: any) => {
      const message = this.translateService.instant("SELECT_LOCATION_FIRST_MSG");
      const header = this.translateService.instant("SELECT_LOCATION");
      const alert = await this.alertCtrl.create({
        header,
        message,
        buttons: [
          {
            text: this.translateService.instant("CANCEL"),
            role: "cancel",
            handler: () => resolve(false),
          },
          {
            text: this.translateService.instant("OK"),
            handler: () => resolve(true),
          },
        ],
        backdropDismiss: false,
        cssClass: 'custom-alert-wrapper'
      });
      await alert.present();
    });
  }

  accountExpire(message: string) {
    return new Promise(async (resolve: any) => {
      const title = this.translateService.instant("ACCOUNT_EXPIRED_TITLE");
      const alert = await this.alertCtrl.create({
        header: title,
        message,
        buttons: [
          {
            text: this.translateService.instant("CANCEL"),
            role: 'cancel',
            handler: () => resolve(false),
          },
          {
            text: this.translateService.instant("AUTHENTICATE"),
            handler: () => resolve(true),
          },
        ],
      });
      await alert.present();
    });
  }

}
